import apiClient from "../../axios/apiClient";

export const getGeneralSettingList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_GENERAL_SETTING_LIST_PENDING" });

      const response = await apiClient.get(
        `/api/v1/company-settings`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_GENERAL_SETTING_LIST_FULFILLED",
        payload: response.data?.data,
        generalSettingCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_GENERAL_SETTING_LIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveGeneralSettingData = (token, data) => async (dispatch) => {
    try {
      dispatch({ type: "ADD_GENERAL_SETTING_PENDING" });
  
      const response = await apiClient.patch(
        `/api/v1/company-settings`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_GENERAL_SETTING_FULFILLED", payload: response.data });
    } catch (error) {
    
      dispatch({ type: "ADD_GENERAL_SETTING_REJECTED", payload: error.response });
    
    }
  };
